import { Badge } from '@skupreme/shared/ui';
import { DateFormat, DateUtility } from '@utility/date';
import type { StorageProviderV2Node } from '../../types-v2';

/** The routing pause fields every V2 provider, row and node carries (null or absent while not paused). */
type RoutingPause = Pick<
  StorageProviderV2Node,
  'routing_paused_at' | 'routing_paused_reason'
>;

/** "Paused for routing since <local date time>." plus the reason when there is one. */
export const routingPausedText = ({
  routing_paused_at: at,
  routing_paused_reason: reason,
}: RoutingPause) =>
  `Paused for routing since ${DateUtility.formatDate(at ?? null, DateFormat.dateTime)}.${reason ? ` ${reason}` : ''}`;

/** EN-4200: the Paused badge of a provider or node that routing skips; nothing while it is not paused. */
export function RoutingPausedBadge({ pause }: { pause: RoutingPause }) {
  if (!pause.routing_paused_at) {
    return null;
  }

  return (
    <span title={routingPausedText(pause)}>
      <Badge tone="warning">Paused</Badge>
    </span>
  );
}
